








import {Component, Prop, Mixins} from 'vue-property-decorator'
import ServiceSelectCard from '@/components/ServiceSelectCard.vue'
import {IServiceTypePriceReverse} from '@/entities'
import radioChoiceMixin from "@/mixins/radioChoiceMixin";
import {IOption} from "@/components/lib/models";

@Component({
  components: {
    ServiceSelectCard
  }
})
export default class ServiceSelect extends Mixins(radioChoiceMixin) {
  @Prop() readonly value!: IServiceTypePriceReverse | null
  @Prop({
    validator(value: any): boolean {
      return !!value?.length
    }
  })
  readonly options!: IOption<IServiceTypePriceReverse>[]

  get currentId(): number | undefined {
    return this.value?.id;
  }

}
